import * as React from 'react';
import sortBy from 'lodash/sortBy';
import { Menu, Table, Grid, Dropdown, Label } from 'semantic-ui-react';
import InlineSvg from './InlineSvg';

class Datatable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      column: null,
      rows: this.props.rows,
      data: this.props.rows[0],
      direction: null,
    };
  }

  handleDropdownChange = (event, result) => {
    this.setState({
      data: this.state.rows[parseInt(result.value, 10)],
    });
  };

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: sortBy(data, [clickedColumn]),
        direction: 'ascending',
      });
      return;
    }

    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    });
  }

  render() {
    const {
      title,
      filter,
      header,
      pagination,
      caption,
      fixed,
      sortable,
      displayMobileHeaders,
    } = this.props;
    const { data, column, direction } = this.state;
    return (
      <div className="datatable" data-testid="datatable">
        {title && (
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <h2>{title}</h2>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
        {filter && (
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Label>Show:</Label>
                <Dropdown
                  defaultValue={filter[0].value}
                  selection
                  onChange={this.handleDropdownChange}
                  options={filter}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
        <Table
          className={`${displayMobileHeaders ? 'table--mobile-headers' : ''}`}
          sortable={sortable ? true : false}
          padded
          striped
          fixed={fixed}
        >
          <Table.Header>
            <Table.Row>
              {header &&
                header.map((header, index) => (
                  <Table.HeaderCell
                    key={index}
                    sorted={column === header ? direction : null}
                    onClick={sortable ? () => this.handleSort(header) : null}
                  >
                    {header}
                  </Table.HeaderCell>
                ))}
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {data &&
              data.map((row, rowIndex) => (
                <Table.Row
                  key={`row${rowIndex}`}
                  className="datatable__body-row"
                >
                  {row.map((cell, colIndex) => (
                    <Table.Cell
                      className="datatable__data-cell"
                      key={`col${rowIndex}${colIndex}`}
                    >
                      {displayMobileHeaders && header && header[colIndex] && (
                        <span className="datatable__mobile-header">
                          {header[colIndex]}
                        </span>
                      )}
                      <span
                        dangerouslySetInnerHTML={{
                          __html: cell,
                        }}
                      />
                    </Table.Cell>
                  ))}
                </Table.Row>
              ))}
          </Table.Body>

          {pagination && (
            <Table.Footer className="datatable__footer">
              <Table.Row className="datatable__footer-row">
                <Table.HeaderCell
                  className="datatable__footer-header"
                  colSpan={header && header.length}
                >
                  <Menu floated="right" pagination>
                    <Menu.Item as="a" icon>
                      <InlineSvg name="chevron-left" color="red" />
                    </Menu.Item>
                    <Menu.Item as="a">1</Menu.Item>
                    <Menu.Item as="a">2</Menu.Item>
                    <Menu.Item as="a">3</Menu.Item>
                    <Menu.Item as="a">4</Menu.Item>
                    <Menu.Item as="a" icon>
                      <InlineSvg name="chevron-right" color="red" />
                    </Menu.Item>
                  </Menu>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          )}
        </Table>
        {caption && <p>{caption}</p>}
      </div>
    );
  }
}

export default Datatable;

export function formatTableHeading({ header }) {
  if (header) {
    return header.map((h) => h.c);
  }
  return null;
}

export function formatTableRTEHeaders({ header }) {
  if (header) {
    return header.map((h) => h.header_cell);
  }
  return null;
}

export function formatTableRTEBody(body) {
  return [body.map((b) => b.columns.map((col) => col.cell))];
}

export function formatTableBody({ body }) {
  return [body.map((b) => b.map((r) => r.c))];
}
